import { defineComponent as _defineComponent } from 'vue'
import ScrollActive from "~/components/ScrollActive";
import { reactive, ref, nextTick, onMounted, computed } from "@nuxtjs/composition-api";

import "perfect-scrollbar/css/perfect-scrollbar.css";

// import {useScrollParent} from "~/composables/useScrollParent";
import { debounce, isNumber } from "~/utils/helpers";

// import VScrollbar from "~/components/VScrollbar.vue";
import { useElementBounding, useScroll, executeTransition, useMutationObserver } from "@vueuse/core";
import { usePerfectScrollbar } from "~/composables/usePerfectScrollbar";
import { update } from "lodash";

interface IProps {
  tag?: string;
  itemTag?: string;
  offset?: number;
  options?: Array<{
    text: string;
    sectionSelector: string;
  }>;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollNav',
  props: {
    tag: { default: "div" },
    itemTag: null,
    offset: { default: 0 },
    options: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { tag: string, itemTag?: string, offset: number, options: Array<{
    text: string;
    sectionSelector: string;
  }> }



const scrollerRef = ref<HTMLElement>();

const wrapRef = ref<HTMLElement>();
// usePerfectScrollbar(scrollerRef, {
//   suppressScrollY: true,
// });

const { width: wrapWidth } = useElementBounding(wrapRef, {
  windowResize: false,
  windowScroll: false,
});

const isOverflow = ref(false);
const checkOverflow = () => {
  isOverflow.value = scrollerRef.value ? scrollerRef.value.scrollWidth > wrapWidth.value : false;
}
useMutationObserver(scrollerRef.value, (...rest) => {
  checkOverflow();
}, {
  childList: true
})

onMounted(() => {
  checkOverflow();
})

const { x, arrivedState } = useScroll(wrapRef);

const onChange = debounce(
  async (
    event: Event,
    currentItem: HTMLElement,
    lastActiveItem: HTMLElement
  ) => {
    if (currentItem) {
      currentItem.scrollIntoView({ behavior: "smooth",inline:'center',block:'nearest'});
      // const to =
      //   currentItem.offsetLeft -
      //   (wrapWidth.value - currentItem.offsetWidth) / 2;
      // scrollTo(to);
    }
  },
  100
);

const scrollTo = async (to: "prev" | "next" | number) => {
  let _to = x.value;
  if (isNumber(to)) {
    _to = to;
  } else if (to === "next") {
    _to += wrapWidth.value;
  } else {
    _to -= wrapWidth.value;
  }


  wrapRef.value?.scrollTo({
    left: _to,
    behavior: "smooth",
    // block:'nearest'
  });

  // await executeTransition(x, x.value, _to, {
  //   transition: [0.5, 0, 0.35, 1],
  //   duration: 300,
  // });
};

return { __sfc: true,props, scrollerRef, wrapRef, wrapWidth, isOverflow, checkOverflow, x, arrivedState, onChange, scrollTo, ScrollActive }
}

})